/*
 *
 * @Copyright 2021 VOID SOFTWARE, S.A.
 *
 */

export enum AppRoute {
    Prediction = '/',
}
